import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { ProfileMenu } from '@/components/ProfileMenu/ProfileMenu';
import { PlatformMenu } from '@/components/PlatformMenu/PlatformMenu';
import ScholasticLogo from '@/assets/images/scholastic-logo.svg';
import ScholasticFlyingPagesLogo from '@/assets/images/scholastic-flying-pages-logo.svg';
import { KnockNotificationFeed } from '@/components/KnockNotificationFeed/KnockNotificationFeed';
import '@knocklabs/react/dist/index.css';

export function Header() {
  const isMobile = useMediaQuery({ query: '(max-width: 639px)' });

  const Logo = isMobile ? ScholasticFlyingPagesLogo : ScholasticLogo;
  return (
    <header className="border-t-8 border-brand-cliffordRed bg-white py-4 shadow-header">
      <a
        className="sr-only z-30 rounded-xs bg-brand-white text-lg text-blue-700 underline focus:not-sr-only focus:absolute focus:ml-10 focus:p-2"
        href="#main"
      >
        Skip to main content
      </a>
      <div className="mx-auto flex w-full items-center justify-between gap-6 px-4 tablet:px-10">
        <Link to="/" className="focus-ring">
          <Logo
            role="img"
            aria-label="scholastic logo"
            data-testid={
              isMobile ? 'flying pages logo' : 'full scholastic logo'
            }
          />
        </Link>

        <div className="flex items-center gap-3">
          <KnockNotificationFeed />
          <PlatformMenu />
          <ProfileMenu />
        </div>
      </div>
    </header>
  );
}
